import { Client } from "@/service/client";
import { ScanRequest } from "@/shared/model/scan_request.model";
import { ScanResponse } from "@/shared/model/scan_response.model";

export class ScanApi {
  private client: Client;

  constructor(client: Client) {
    this.client = client;
  }

  async create(data: {
    website: string;
    keyword_list: string[];
  }): Promise<ScanRequest> {
    const response = await this.client.fetch(`/scan`, {
      method: "POST",
      body: JSON.stringify(data),
    });

    const json = await response.json();

    return json.data;
  }

  async list(): Promise<ScanRequest[]> {
    const response = await this.client.fetch(`/scan`);

    const json = await response.json();

    return json.data;
  }

  async delete(id_scan_request: string): Promise<void> {
    await this.client.fetch(`/scan/${id_scan_request}`, {
      method: "DELETE",
    });
  }

  async process(id_scan_request: string): Promise<ScanResponse[]> {
    const response = await this.client.fetch(
      `/scan/${id_scan_request}/process`,
      {
        method: "POST",
      }
    );

    const json = await response.json();

    return json.data;
  }

  async scanResponse(id_scan_request: string): Promise<ScanResponse[]> {
    const response = await this.client.fetch(
      `/scan/${id_scan_request}/scan-response`
    );

    const json = await response.json();

    return json.data;
  }
}
